import { RouteConfig } from "vue-router"

/**
 * RouteConfigを定義します: [NegativeDetail]。
 */
export const NegativeDetailRouteConfig: RouteConfig = {
  path: "/NegativeDetail",
  name: "NegativeDetail",
  component: () => import("%%/views/negativeDetail/NegativeDetail.vue"),
  meta: {
    reload: false,
    authRequired: true,
  },
}
